<template>
    <div class="manage-script">  
      <div class="pa-5" style="display: flex; justify-content: space-between;; padding: 0 12px">      
        <!-- <div class="ml-5">
          <div>
              <v-menu
                  bottom
                  right
                  offset-y
                  :internal-activator="true"
                  content-class="no-contain overflow-visible"
                  :close-on-content-click="false"
                  v-model="openMenu"
              >
                  <template v-slot:activator="{ attrs, on }">
                    <v-btn style="padding: 0px 25px !important; margin-right: 10px;"
                           color="primary" dark v-on="on">
                      <span>Tìm kiếm</span>
                      <v-icon style="margin-left: 10px; margin-right: -20px;">mdi-chevron-down</v-icon>
                    </v-btn>
                  </template>
  
                  <v-card
                      width="400px"
                      outlined
                      class="ma-0"
                  >
                    <v-row class="px-5 py-5 mt-3">
                      <v-col
                          class="py-0"
                          cols="12">
                        <v-text-field
                            placeholder="Nhập tên"
                            label="Tìm kiếm theo tên"
                            clearable
                            @keyup.enter="searchUser"
                            v-model="fillter.keyword"
                        />
                      </v-col>
                    </v-row>
                    <div class="text-center mb-4">
                      <v-btn
                          class="primary mx-0"
                          @click="searchUser"
                      >
                        <v-icon>mdi-magnify</v-icon>Tìm kiếm
                      </v-btn>
                    </div>
                  </v-card>
              </v-menu>
          </div>
        </div>
       
        <div style="display: flex; justify-content: flex-end; padding: 0 12px">
         
          <div class="text-right mb-1 mt-2">
            {{ showContactsIndex() }}
            <v-btn
              small
              class="pagination-btn-left ml-4"
              @click="function() {currentPage--}"
              :disabled="currentPage == 1"
            >
              <v-icon>mdi-menu-left</v-icon>
            </v-btn>
            <v-btn
              small
              class="pagination-btn-right"
              @click="function() {currentPage++}"
            >
              <v-icon>mdi-menu-right</v-icon>
            </v-btn>
          </div>
          <div style="width: 35px">
            <v-text-field
              class="pt-0"
              v-model="currentPage"
              min="1"
              step="1"
              type="number"
            >
            </v-text-field>
          </div>
        </div> -->
        <div>
          <!-- <v-btn color="pink" @click="showModel= true, itemBrand = {}"><v-icon>mdi-plus</v-icon> Tạo mới</v-btn> -->
        </div>
      </div>
      <div class="contact-table pb-5 mx-9" id="contact-table">
        <v-simple-table
          class="table-layout table-contact table-fixed "
          style="border: 0;"
        >
          <template v-slot:default>
            <thead>
              <tr>
                <th
                  class="font-weight-regular --module-title scroll-layout-left name-sale"
                  style="left: 0px"
                >
                Brandname
                </th>
                <th
                  class="font-weight-regular --module-title scroll-layout-left name-code"
                  style="left: 200px"
                >
                Mã
                </th>
               
                <th
                  class="font-weight-regular --module-title"
                >
                    Thao tác
                </th>
              </tr>
            </thead>
            <tbody  v-for="(item, index) in brands" :key="index" class="bg-hover">
                <tr :key="index">
                    <td
                    class="font-weight-regular --module-title scroll-layout-left name-sale pl-10"
                    style="left: 0px"
                    >
                    {{ item.name }}
                    </td>
                    <td
                    class="scroll-layout-left"
                    style="left: 200px"
                    >
                    {{ item.code }}
                    </td>
                    
                    <td>
                        <v-icon class="mr-2" color="#0395EE" @click="showModelScript(item)">mdi-alert-circle</v-icon>
                    </td>
                </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
      <v-dialog width="600" v-model="showModel">
        <ModelCreateBrands @closePopup="showModel = false" @getListBrands="emitGetList" v-if="showModel" :itemBrand="itemBrand"/>
      </v-dialog>
    </div>
  </template>
  <script>
  import RepositoryFactory from "../../repositories/RepositoryFactory";
  const ScriptRepository = RepositoryFactory.get("script");
  import ModelCreateBrands from "./model/ModelCreateBrands.vue";
  export default {
    components : {
      ModelCreateBrands
    },
    data() {
      return {
        brands: [],
        limit: 10,
        currentPage: 1,
        fillter: {
          keyword: null
        },
        openMenu: false,
        showModel: false,
        itemBrand: {}
      };
    },
    created() {
      this.getListBrandName();
      // this.getListBrands()
    },
    watch: {
      currentPage: {
        handler(val) {
          const params = {
            page: val,
            ...this.fillter
          };
          this.getListBrandName(params);
        },
      },
    },
    methods: {
      showContactsIndex() {
        if (this.scripts.length > 0) {
          let maxIndex = parseInt(this.currentPage) * parseInt(this.limit);
          return maxIndex - parseInt(this.limit) + 1 + " - " + maxIndex;
        } else {
          return "0 - 0";
        }
      },
      async getListBrandName(params) {
        const res = await ScriptRepository.getListBrandName(params);
        this.brands = _.get(res, "data", []);
      },
      searchUser() {
        const params = this.fillter
        this.getListKB(params);
        this.openMenu = false
      },
      emitGetList() {
        this.showModel = false
        this.getListBrandName()
      },
      showModelScript(item) {
        console.log("item: ", item);
        this.showModel = true
        this.itemBrand = item
      }
    },
  };
  </script>
  <style lang="scss" scoped>
  .manage-script {
    .table-contact td {
    position: relative;
    border-right: 1px solid #d2d2d2;
    font-size: 13px !important;
    color: #000000;
}
  }
  .font-weight-regular {
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
    cursor: pointer;
  }
  .--module-title {
    font-weight: bold !important;
    font-family: Roboto;
    font-size: 13px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0px;
    text-align: left;
  }
  .scroll-layout-left {
    position: sticky;
  }
  .contact-table th.name-sale {
    min-width: 200px;
  }
  .contact-table th.name-code {
    min-width: 200px;
  }
  .contact-table th.name-script {
    min-width: 100px;
  }
  thead tr th {
    background: #f2f2f2 !important;
  }
  

  input.input-scriptCode {
      background: white;
      height: 37px;
      width: 108px;
      padding-left: 10px;
      border-radius: 4px;
      font-size: 14px;
      margin-bottom: 3px;
      font-weight: 400;
      color: #575757;
      outline: none;
  }
  input[type=number] {
    -moz-appearance: textfield;
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  
  </style>